import { DownloadIcon, Eye_1Icon } from "vega-icons";

import { Switch } from "@vega-core/components/Switch/Switch";
import { Tooltip } from "@vega-core/components/Tooltip/Tooltip";
import { m } from "@vega-core/paraglide/messages";

type DownloadToggleProps = {
  isDownloadable: boolean;
  onChange?: () => void;
  dataTestId: string;
};

const ICON_CLASS = "block h-4 w-4 fill-text/primary";

export function DownloadToggle({
  isDownloadable,
  onChange,
  dataTestId,
}: DownloadToggleProps) {
  const isLocked = onChange === undefined;

  const leftIcon = (
    <Tooltip content={m.coInvestments_dataRoom_fileToggle_viewOnly()}>
      <span>
        <Eye_1Icon className={ICON_CLASS} />
      </span>
    </Tooltip>
  );

  const rightIcon = (
    <Tooltip content={m.coInvestments_dataRoom_fileToggle_downloadable()}>
      <span>
        <DownloadIcon className={ICON_CLASS} />
      </span>
    </Tooltip>
  );

  const switchElement = (
    <Switch
      ariaLabel={m.coInvestments_dataRoom_fileToggle_ariaLabel()}
      checked={isDownloadable}
      dataTestId={dataTestId}
      disabled={isLocked}
      leftIcon={leftIcon}
      onChange={isLocked ? undefined : onChange}
      rightIcon={rightIcon}
      size="sm"
    />
  );

  if (isLocked) {
    return (
      <Tooltip
        content={m.coInvestments_dataRoom_fileToggle_alwaysDownloadableTooltip()}
      >
        <span className="inline-flex">{switchElement}</span>
      </Tooltip>
    );
  }

  return switchElement;
}
